// extracted by mini-css-extract-plugin
var _1 = "DarkModal__DarkModal___PQ0Hl";
var _2 = "DarkModal__icon___TMPXZ";
var _3 = "DarkModal__list-item___gdebP";
var _4 = "DarkModal__not-a-wrapper___PXWpi";
var _5 = "DarkModal__wiggle___P8mnm";
export { _1 as "DarkModal", _2 as "icon", _3 as "list-item", _4 as "not-a-wrapper", _5 as "wiggle" }
